<template>
  <div class="explorer-menu" :class="{'is-active': activeMenu}">
    <div class="explorer-inner">
      <div class="explorer-container">
        <!--Header-->
        <div class="explorer-header">
          <h3>Aplicaciones</h3>
          <a class="delete is-medium" @click="$store.commit('toggleMenuApps')"></a>
        </div>
        <!--List-->
        <div class="explore-list">
          <!-- item -->
          <router-link
              class="explore-item is-coming-soon"
              :to="{name:'tools'}">
            <img src="@/assets/tools.png" alt="Call center">
            <span class="coming-soon">
              {{ $t('common.tools') }}
            </span>
          </router-link>
          <router-link
              class="explore-item is-coming-soon"
              :to="{name:'sedena-tools'}">
            <img src="@/assets/sedena-tools.png" alt="Herramientas SEDENA">
            <span class="coming-soon">
               Herramientas SEDENA
            </span>
          </router-link>
          <router-link
              class="explore-item is-coming-soon"
              :to="{name:'eden'}">
            <img src="@/assets/eden.png" alt="Herramientas EDEN">
            <span class="coming-soon">
               Herramientas EDEN
            </span>
          </router-link>
          <button
              class="explore-item is-coming-soon"
              @click="goInterfazHRAE"
          >
            <img src="@/assets/interfaces.png" alt="Interfaces">
            <span class="coming-soon">
              Interfaz con equipos
            </span>
          </button>
          <button
              v-if="$auth.user().enable_biopsy_dr_vagon"
              class="explore-item is-coming-soon"
              @click="goBiopsyDrVagon"
          >
            <img src="@/assets/biopsy-dr-vagon.png" alt="Interfaces">
            <span class="coming-soon">
              Biopsia Dr. Vagon
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppMenu",
  computed: {
    activeMenu() {
      return this.$store.state.menu.menuApps;
    }
  },
  methods: {
    goInterfazHRAE() {
      this.$loader.show();
      this.$http.post('/interfaces/generate/token').then(({data}) => {
        const urlRemote = data.url;
        const token = data.token;
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = `${urlRemote}integration/access/${token}`;
        document.body.appendChild(a)
        a.click()
      }).finally(() => {
        this.$loader.hide();
      });
    },
    goBiopsyDrVagon() {
      const urlRemote = window.location.href.startsWith('http://recepcion.lapi.site') ? 'http://drvagon.lapi.site:5173/' : 'https://alfalab.lapi.mx/vagon-tools';
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = `${urlRemote}`;
      document.body.appendChild(a)
      a.click()
    }
  }
}
</script>

<style scoped>
.explore-item {
  background: transparent !important;
}

.explore-item img {
  object-fit: contain !important;
  filter: none !important;
}
</style>
